const recordCar = () => import('@/pages/recordCar/index')
const createRecord = () => import('@/pages/recordCar/createRecord')
const recordItemDetail = () => import('@/pages/recordCar/recordItemDetail')
const recordDetail = () => import('@/pages/recordCar/recordDetail')
const notComponyrecordItemDetail = () => import('@/pages/recordCar/notComponyrecordItemDetail')
const autoComponyrecordItemDetail = () => import('@/pages/recordCar/autoComponyrecordItemDetail')
const recordRecheckDetail = () => import('@/pages/recordCar/recordRecheckDetail')
const statusRecordCreate = () => import('@/pages/recordCar/statusRecordCreate')
const recordStatusDetail = () => import('@/pages/recordCar/recordStatusDetail')
export default [{
  path: '/recordCar',
  name: '/recordCar',
  component: recordCar,
  meta: {
    storeKey: 'trs.recordCar.index'
  }
},
{
  path: '/createRecord',
  name: '/createRecord',
  component: createRecord,
  meta: {}
},
{
  path: '/recordItemDetail',
  name: '/recordItemDetail',
  component: recordItemDetail,
  meta: {}
},
{
  path: '/recordDetail',
  name: '/recordDetail',
  component: recordDetail,
  meta: {}
},
{
  path: '/notComponyrecordItemDetail',
  name: '/notComponyrecordItemDetail',
  component: notComponyrecordItemDetail,
  meta: {}
},
{
  path: '/autoComponyrecordItemDetail',
  name: '/autoComponyrecordItemDetail',
  component: autoComponyrecordItemDetail,
  meta: {}
},
{
  path: '/recordRecheckDetail',
  name: '/recordRecheckDetail',
  component: recordRecheckDetail,
  meta: {}
},
{
  path: '/statusRecordCreate',
  name: '/statusRecordCreate',
  component: statusRecordCreate,
  meta: {}
},
{
  path: '/recordStatusDetail',
  name: '/recordStatusDetail',
  component: recordStatusDetail,
  meta: {}
}
]



// WEBPACK FOOTER //
// ./src/router/recordCar/index.js